export const LIB_VERSION = "0.1.36";
